module.exports = {
  PAGINATION_PARAM: 'page',
  CALENDAR_DAILY: 'resourceTimelineDay',
  CALENDAR_WEEKLY: 'resourceTimelineWeekDays',
  CALENDAR_MONTHLY: 'resourceTimelineMonth',
  CALENDAR_DAYGRID: 'dayGridMonth',
  LIST_CALENDAR_DAILY: 'listDay',
  LIST_VIEW:'listView',
};
